// extracted by mini-css-extract-plugin
export default {"cell":"cI6e8X"};